export default [
    {
        path: '/payment-confirmation/:id/:amount?',
        name: 'PaymentConfirmation',
        component: () => import('@/views/payments/payment_confirmation'),
        meta: { pageTitle: 'Payments', breadcrumb: [{ text: 'Payments' }] },
    },
    {
        path: '/payment-info/:id',
        name: 'PaymentInfo',
        component: () => import('@/views/payments/show'),
        meta: { pageTitle: 'Payments', breadcrumb: [{ text: 'Payments' }] },
    },

]
